<template>
    <div>
        <div id="mainhold">
            <div id="mainbod">
                <div class="amTealregular">Platform Policies</div>
                <div class="section">
                    <div class="thirds bgTeal amWhiteregular cText" v-if="!atPolicy" @click="showPolicy">PRIVACY</div>
                    <div class="thirds bgMint amWhiteregular cText" v-if="atPolicy">PRIVACY</div>
                    <div class="thirds bgTeal amWhiteregular cText" v-if="!atTerms" @click="showTerms">TERMS</div>
                    <div class="thirds bgMint amWhiteregular cText" v-if="atTerms">TERMS</div>
                    <div class="thirds bgTeal amWhiteregular cText" v-if="!atGuidelines" @click="showGuidelines">GUIDELINES</div>
                    <div class="thirds bgMint amWhiteregular cText" v-if="atGuidelines">GUIDELINES</div>
                    <div class="thirds bgTeal amWhiteregular cText" v-if="!atCookies" @click="showCookies">COOKIES</div>
                    <div class="thirds bgMint amWhiteregular cText" v-if="atCookies">COOKIES</div>
                </div>
                <div v-if="atPolicy">
                    <div class="section" v-if="isSelecting">
                        <textarea class="textview" type="text" v-model="policyContent"></textarea>
                        <input class="textbox" type="text" v-model="policyUse">
                        <div class="wrap"><div class="tealBtn" @click="updateMain">UPDATE</div></div>
                        <div class="wrap"><div class="tealBtn" @click="editPosted(policyUse)">EDIT POSTED</div></div>
                        <div class="wrap"><div class="tealBtn" @click="createNew">CREATE NEW</div></div>
                    </div>
                    <div class="section" v-if="isEditing">
                        <div class="listCol">
                            <div v-for="(policy, index) in privacypolicy" :key="index">
                                <div class="wrap amTealregular" @click="showSelection(policy)">{{policy.order}} | {{policy.title}}</div>
                        </div>
                        </div>
                        <div class="contentCol">
                            <input type="text" class="textbox" v-model="itemSelect">
                            <input type="text"  class="textbox" v-model="itemTitle">
                            <textarea class="textview" v-model="itemContent"></textarea>
                            <div class="section"><div class="tealBtn" @click="updateEntry">UPDATE</div></div>
                        </div>
                    </div>
                    <div class="section" v-if="isCreating">
                        <div class="section" v-if="!didEnter">
                            <div class="amTeallight">What is the effective date of this policy? mmddyyyy</div>
                            <input type="text" v-model="policyUse">
                            <div class="wrap"><div class="tealBtn" @click="createPolicy">CREATE POLICY GROUP</div></div>
                        </div>
                        <div class="section" v-if="didEnter">
                            <div class="listCol">
                                <div v-for="(policy, index) in privacypolicy" :key="index">
                                    <div class="wrap amTealregular" @click="showSelection(policy)">{{policy.order}} | {{policy.title}}</div>
                                </div> 
                            </div>
                            <div class="contentCol">
                                <input type="text" v-model="itemSelect">
                                <input type="text"  class="textbox" v-model="itemTitle">
                                <textarea class="textview" v-model="itemContent"></textarea>
                                <div class="section"><div class="tealBtn" @click="postPolicy">SEND</div></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="atTerms">
                    <div class="section" v-if="isSelecting">
                        <textarea class="textview" type="text" v-model="termsContent"></textarea>
                        <input class="textbox" type="text" v-model="termsUse">
                        <div class="wrap"><div class="tealBtn" @click="updateMain">UPDATE</div></div>
                        <div class="wrap"><div class="tealBtn" @click="editPosted(termsUse)">EDIT POSTED</div></div>
                        <div class="wrap"><div class="tealBtn" @click="createNew">CREATE NEW</div></div>
                    </div>
                    <div class="section" v-if="isEditing">
                        <div class="listCol">
                            <div v-for="(policy, index) in termsofuse" :key="index">
                                <div class="wrap amTealregular" @click="showSelection(policy)">{{policy.order}} | {{policy.title}}</div>
                        </div>
                        </div>
                        <div class="contentCol">
                            <input type="text" class="textbox" v-model="itemSelect">
                            <input type="text"  class="textbox" v-model="itemTitle">
                            <textarea class="textview" v-model="itemContent"></textarea>
                            <div class="section"><div class="tealBtn" @click="updateEntry">UPDATE</div></div>
                        </div>
                    </div>
                    <div class="section" v-if="isCreating">
                        <div class="section" v-if="!didEnter">
                            <div class="amTeallight">What is the effective date of this policy? mmddyyyy</div>
                            <input type="text" v-model="termsUse">
                            <div class="wrap"><div class="tealBtn" @click="createPolicy" >CREATE POLICY GROUP</div></div>
                        </div>
                        <div class="section" v-if="didEnter">
                            <div class="listCol">
                                <div v-for="(policy, index) in termsofuse" :key="index">
                                    <div class="wrap amTealregular" @click="showSelection(policy)">{{policy.order}} | {{policy.title}}</div>
                                </div> 
                            </div>
                            <div class="contentCol">
                                <input type="text" v-model="itemSelect">
                                <input type="text"  class="textbox" v-model="itemTitle">
                                <textarea class="textview" v-model="itemContent"></textarea>
                                <div class="section"><div class="tealBtn" @click="postPolicy">SEND</div></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="atGuidelines">
                    <div class="section" v-if="isSelecting">
                        <textarea class="textview" type="text" v-model="guideContent"></textarea>
                        <input class="textbox" type="text" v-model="guideUse">
                        <div class="wrap"><div class="tealBtn" @click="updateMain">UPDATE</div></div>
                        <div class="wrap"><div class="tealBtn" @click="editPosted(guideUse)">EDIT POSTED</div></div>
                        <div class="wrap"><div class="tealBtn" @click="createNew">CREATE NEW</div></div>
                    </div>
                    <div class="section" v-if="isEditing">
                        <div class="listCol">
                            <div v-for="(policy, index) in userguidelines" :key="index">
                                <div class="wrap amTealregular" @click="showSelection(policy)">{{policy.order}} | {{policy.title}}</div>
                        </div>
                        </div>
                        <div class="contentCol">
                            <input type="text" class="textbox" v-model="itemSelect">
                            <input type="text"  class="textbox" v-model="itemTitle">
                            <textarea class="textview" v-model="itemContent"></textarea>
                            <div class="section"><div class="tealBtn" @click="updateEntry">UPDATE</div></div>
                        </div>
                    </div>
                    <div class="section" v-if="isCreating">
                        <div class="section" v-if="!didEnter">
                            <div class="amTeallight">What is the effective date of this policy? mmddyyyy</div>
                            <input type="text" v-model="guideUse">
                            <div class="wrap"><div class="tealBtn" @click="createPolicy" >CREATE POLICY GROUP</div></div>
                        </div>
                        <div class="section" v-if="didEnter">
                            <div class="listCol">
                                <div v-for="(policy, index) in userguidelines" :key="index">
                                    <div class="wrap amTealregular" @click="showSelection(policy)">{{policy.order}} | {{policy.title}}</div>
                                </div> 
                            </div>
                            <div class="contentCol">
                                <input type="text" v-model="itemSelect">
                                <input type="text"  class="textbox" v-model="itemTitle">
                                <textarea class="textview" v-model="itemContent"></textarea>
                                <div class="section"><div class="tealBtn" @click="postPolicy">SEND</div></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="atCookies">
                    <div class="section" v-if="isSelecting">
                        <textarea class="textview" type="text" v-model="cookieContent"></textarea>
                        <input class="textbox" type="text" v-model="cookieUse">
                        <div class="wrap"><div class="tealBtn" @click="updateMain">UPDATE</div></div>
                        <div class="wrap"><div class="tealBtn" @click="editPosted(cookieUse)">EDIT POSTED</div></div>
                        <div class="wrap"><div class="tealBtn" @click="createNew">CREATE NEW</div></div>
                    </div>
                    <div class="section" v-if="isEditing">
                        <div class="listCol">
                            <div v-for="(policy, index) in userguidelines" :key="index">
                                <div class="wrap amTealregular" @click="showSelection(policy)">{{policy.order}} | {{policy.title}}</div>
                        </div>
                        </div>
                        <div class="contentCol">
                            <input type="text" class="textbox" v-model="itemSelect">
                            <input type="text"  class="textbox" v-model="itemTitle">
                            <textarea class="textview" v-model="itemContent"></textarea>
                            <div class="section"><div class="tealBtn" @click="updateEntry">UPDATE</div></div>
                        </div>
                    </div>
                    <div class="section" v-if="isCreating">
                        <div class="section" v-if="!didEnter">
                            <div class="amTeallight">What is the effective date of this policy? mmddyyyy</div>
                            <input type="text" v-model="cookieUse">
                            <div class="wrap"><div class="tealBtn" @click="createPolicy" >CREATE POLICY GROUP</div></div>
                        </div>
                        <div class="section" v-if="didEnter">
                            <div class="listCol">
                                <div v-for="(policy, index) in cookiepolicy" :key="index">
                                    <div class="wrap amTealregular" @click="showSelection(policy)">{{policy.order}} | {{policy.title}}</div>
                                </div> 
                            </div>
                            <div class="contentCol">
                                <input type="text" v-model="itemSelect">
                                <input type="text"  class="textbox" v-model="itemTitle">
                                <textarea class="textview" v-model="itemContent"></textarea>
                                <div class="section"><div class="tealBtn" @click="postPolicy">SEND</div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import db from '../main'
export default {
    name: "policies",
    data(){
        return {
            atPolicy: false,
            atTerms: false,
            atGuidelines: false,
            atCookies: false,
            policyContent: "",
            policyUse: "",
            termsContent: "",
            termsUse: "",
            guideContent: "",
            guideUse:"",
            cookieUse: "",
            cookieContent: "",
            termsofuse: [],
            userguidelines: [],
            privacypolicy: [],
            cookiepolicy: [],
            isEditing: false,
            isCreating: false,
            assignedDocument: {},
            isSelecting: true,
            itemSelect: "",
            itemTitle: "",
            itemContent: "",
            didEnter: false,
        }
    },
    methods: {
        createPolicy(){
            if(this.atPolicy){
             if(this.policyUse !== ""){
                 this.fetchPolicy()
                 this.didEnter = true
             }
            } else if (this.atGuidelines){
                if(this.guideUse !== ""){
                    this.fetchGuidelines()
                    this.didEnter = true
                }
            } else if(this.atTerms){
                if(this.termsUse !== ""){
                    this.fetchTerms()
                    this.didEnter = true
                }
            } else if (this.atCookies){
                if(this.cookieUse !== ""){
                    this.fetchCookies()
                    this.didEnter = true
                }
            }
        },
        fetchPolicy(){
               this.privacypolicy = []
                db.collection('policies').doc('privacypolicy').collection(this.policyUse).get().then(docs => {
                    docs.forEach(doc => {
                        const data = doc.data();
                        const docID = doc.id;
                        data.id = docID
                        this.privacypolicy.push(data)
                    })
                })
        },
        fetchTerms(){
            this.termsofuse = []
                db.collection('policies').doc('termsofuse').collection(this.termsUse).get().then(docs => {
                    docs.forEach(doc => {
                        const data = doc.data();
                        const docID = doc.id;
                        data.id = docID
                        this.termsofuse.push(data)
                    })
                })
        },
        fetchGuidelines(){
            this.userguidelines = []
                db.collection('policies').doc('userconduct').collection(this.guideUse).get().then(docs => {
                    docs.forEach(doc => {
                        const data = doc.data();
                        const docID = doc.id;
                        data.id = docID
                        this.userguidelines.push(data)
                    })
                })
            
        },
        fetchCookies(){
            this.cookiepolicy = []
                db.collection('policies').doc('cookies').collection(this.cookieUse).get().then(docs => {
                    docs.forEach(doc => {
                        const data = doc.data();
                        const docID = doc.id;
                        data.id = docID
                        this.cookiepolicy.push(data)
                    })
                })
            
        },
        showCookies(){
            this.atPolicy = false
            this.atTerms = false
            this.atGuidelines = false
            this.atCookies = true
            this.isSelecting = true
            this.isEditing = false
            this.isCreating = false
            this.didEnter = false
            
            db.collection('policies').doc('cookies').get().then(doc => {
                if(doc){
                    const data = doc.data();
                    this.cookieUse = data.use;
                    this.cookieContent = data.content;
                }
            })
        },
        showPolicy(){
            this.atPolicy = true
            this.atTerms = false
            this.atGuidelines = false
            this.atCookies = false
            this.isSelecting = true
            this.isEditing = false
            this.isCreating = false
            this.didEnter = false
            
            db.collection('policies').doc('privacypolicy').get().then(doc => {
                if(doc){
                    const data = doc.data();
                    this.policyUse = data.use;
                    this.policyContent = data.content;
                }
            })
        },
        showTerms(){
            this.atPolicy = false
            this.atTerms = true
            this.atGuidelines = false
            this.atCookies = false
            this.isSelecting = true
            this.isEditing = false
            this.isCreating = false
            this.didEnter = false

            db.collection('policies').doc('termsofuse').get().then(doc => {
                if(doc){
                    const data = doc.data();
                    this.termsUse = data.use;
                    this.termsContent = data.content;
                }
            })
        },
        showGuidelines(){
            this.atPolicy = false
            this.atTerms = false
            this.atGuidelines = true
            this.atCookies = false
            this.isSelecting = true
            this.isEditing = false
            this.isCreating = false
            this.didEnter = false

            db.collection('policies').doc('userconduct').get().then(doc => {
                if(doc){
                    const data = doc.data();
                    this.guideUse = data.use;
                    this.guideContent = data.content;
                }
            })
        },
        showSelection(assignedDoc){
            this.itemSelect = assignedDoc.order;
            this.itemTitle = assignedDoc.title;
            this.itemContent = assignedDoc.content;
            this.assignedDocument = assignedDoc
        },
        editPosted(policyUse){
            this.isEditing = true
            this.isCreating = false
            this.isSelecting = false

            if(this.atPolicy){
                this.privacypolicy = []
                db.collection('policies').doc('privacypolicy').collection(policyUse).orderBy('order', 'asc').get().then(docs => {
                    docs.forEach(doc =>{
                        const data = doc.data();
                        const docID = doc.id;
                        data.id = docID
                        this.privacypolicy.push(data)
                    })
                })
            } else if (this.atTerms){
                this.termsofuse = []
                db.collection('policies').doc('termsofuse').collection(policyUse).orderBy('order', 'asc').get().then(docs => {
                    docs.forEach(doc => {
                        const data = doc.data();
                        const docID = doc.id;
                        data.id = docID
                        this.termsofuse.push(data)
                    })
                })
            } else if (this.atGuidelines){
                this.userguidelines = []
                db.collection('policies').doc('userconduct').collection(policyUse).orderBy('order', 'asc').get().then(docs => {
                    docs.forEach(doc => {
                        const data = doc.data();
                        const docID = doc.id;
                        data.id = docID
                        this.userguidelines.push(data)
                    })
                })
            } else if (this.atCookies){
                this.cookiepolicy = []
                db.collection('policies').doc('cookies').collection(policyUse).orderBy('order', 'asc').get().then(docs => {
                    docs.forEach(doc => {
                        const data = doc.data();
                        const docID = doc.id;
                        data.id = docID
                        this.userguidelines.push(data)
                    })
                })
            }
        },
        createNew(){
            this.isEditing = false
            this.isCreating = true
            this.isSelecting = false
        },
        postPolicy(){
            if(this.atPolicy){
                if(this.itemTitle !== "" || this.itemSelect !== "" || this.itemContent !== ""){
                    console.log(this.policyUse, "Hi")
                db.collection('policies').doc('privacypolicy').collection(this.policyUse).doc().set({
                    order:parseInt(this.itemSelect),
                    content:this.itemContent,
                    title:this.itemTitle
                }, {merge:true}).then(() => {
                    alert('Made new Entry')
                    this.fetchPolicy()
                    this.itemSelect = "",
                    this.itemContent = "",
                    this.itemTitle = ""
                })
                } else {
                    alert('Cannot create Empty selection.')
                }
            } else if (this.atTerms){
                if(this.itemTitle !== "" || this.itemSelect !== "" || this.itemContent !== ""){
                db.collection('policies').doc('termsofuse').collection(this.termsUse).doc().set({
                    order:parseInt(this.itemSelect),
                    content:this.itemContent,
                    title:this.itemTitle
                }, {merge:true}).then(() => {
                    alert('Made new Entry')
                    this.fetchTerms()
                    this.itemSelect = "",
                    this.itemContent = "",
                    this.itemTitle = ""
                })
                } else {
                    alert('Cannot create Empty selection.')
                }
            } else if (this.atGuidelines){
                if(this.itemTitle !== "" || this.itemSelect !== "" || this.itemContent !== ""){
                db.collection('policies').doc('userconduct').collection(this.guideUse).doc().set({
                    order:parseInt(this.itemSelect),
                    content:this.itemContent,
                    title:this.itemTitle
                }, {merge:true}).then(() => {
                    alert('Made entry Entry')
                    this.fetchGuidelines()
                    this.itemSelect = "",
                    this.itemContent = "",
                    this.itemTitle = ""
                })
                } else {
                    alert('Cannot create Empty selection.')
                }
            } else if (this.atCookies){
                if(this.itemTitle !== "" || this.itemSelect !== "" || this.itemContent !== ""){
                db.collection('policies').doc('cookies').collection(this.cookieUse).doc().set({
                    order:parseInt(this.itemSelect),
                    content:this.itemContent,
                    title:this.itemTitle
                }, {merge:true}).then(() => {
                    alert('Made entry Entry')
                    this.fetchCookies()
                    this.itemSelect = "",
                    this.itemContent = "",
                    this.itemTitle = ""
                })
                } else {
                    alert('Cannot create Empty selection.')
                }
            }
        },
        updateEntry(){
            const docdata = this.assignedDocument
            if(this.atPolicy){
                if(this.itemTitle !== "" || this.itemSelect !== "" || this.itemContent !== ""){
                    db.collection('policies').doc('privacypolicy').collection(this.policyUse).doc(docdata.id).update({
                    order:this.itemSelect,
                    content:this.itemContent,
                    title:this.itemTitle
                }).then(() => {
                    alert('Updated Entry', this.itemSelect)
                    this.itemSelect = "",
                    this.itemContent = "",
                    this.itemTitle = ""
                })
                } else {
                    alert('Cannot update Empty selection.')
                }
            } else if (this.atTerms){
                if(this.itemTitle !== "" || this.itemSelect !== "" || this.itemContent !== ""){
                    db.collection('policies').doc('termsofuse').collection(this.termsUse).doc(docdata.id).update({
                    order:this.itemSelect,
                    content:this.itemContent,
                    title:this.itemTitle
                }).then(() => {
                    alert('Updated Entry', this.itemSelect)
                    this.itemSelect = "",
                    this.itemContent = "",
                    this.itemTitle = ""
                })
                } else {
                    alert('Cannot update Empty selection.')
                }
            } else if (this.atGuidelines){
                if(this.itemTitle !== "" || this.itemSelect !== "" || this.itemContent !== ""){
                    db.collection('policies').doc('userconduct').collection(this.guideUse).doc(docdata.id).update({
                    order:this.itemSelect,
                    content:this.itemContent,
                    title:this.itemTitle
                }).then(() => {
                    alert('Updated Entry', this.itemSelect)
                    this.itemSelect = "",
                    this.itemContent = "",
                    this.itemTitle = ""
                })
                } else {
                    alert('Cannot update Empty selection.')
                }
            } else if (this.atCookies){
                if(this.itemTitle !== "" || this.itemSelect !== "" || this.itemContent !== ""){
                    db.collection('policies').doc('cookies').collection(this.guideUse).doc(docdata.id).update({
                    order:this.itemSelect,
                    content:this.itemContent,
                    title:this.itemTitle
                }).then(() => {
                    alert('Updated Entry', this.itemSelect)
                    this.itemSelect = "",
                    this.itemContent = "",
                    this.itemTitle = ""
                })
                } else {
                    alert('Cannot update Empty selection.')
                }
            }
        },
        updateMain(){
            if(this.atPolicy){
                db.collection('policies').doc('privacypolicy').set({
                    content:this.policyContent,
                    use:this.policyUse
                },{merge:true}).then(() => {
                    alert('Hello, we updated the PRIVACY CONTENT Message')
                })
            } else if(this.atTerms){
                 db.collection('policies').doc('termsofuse').set({
                    content:this.termsContent,
                    use:this.termsUse
                },{merge:true}).then(() => {
                    alert('Hello, we updated the Terms Message')
                })
            } else if (this.atGuidelines){
                 db.collection('policies').doc('userconduct').set({
                    content:this.guideContent,
                    use:this.guideUse
                },{merge:true}).then(() => {
                    alert('Hello, we updated the User Conduct Message')
                })
            } else if (this.atCookies){
                 db.collection('policies').doc('cookies').set({
                    content:this.cookieContent,
                    use:this.cookieUse
                },{merge:true}).then(() => {
                    alert('Hello, we updated the User Conduct Message')
                })
            }
        }
    }
}
</script>

<style scoped>
#mainhold {
    width: 100vw;
    height: 100vh;
    background-color: whitesmoke;
    position: absolute;
    z-index: 100;
}

#mainbod {
    width: 90vw;
    height: auto;
    margin-top: 5%;
    margin-left: 5%;
}

.wrap {
    width: 100%;
    height: auto;
    margin-top: 2%;
    margin-bottom: 2%;
}
.listCol{
    width: 33%;
    height: auto;
    float: left;
    clear: right;
    margin-right: 2%;
}
.contentCol{
    width: 60%;
    height: auto;
    float: left;
    clear: right;
    position: fixed;
    margin-top: 200px;
    margin-left: 35%;
    left: 0;
    top: 0;
}
.textbox {
    width: 100%;
    height: auto;
    border-style: none;
    font-family: 'cocomatpro-regular';
    font-size: .85em;
    color: black;
    border-bottom-color: #00a89d;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    margin-bottom: 10px;
}

.textview {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    border-style: none;
    font-family: 'cocomatpro-regular';
    font-size: .85em;
    color: black;
    border-bottom-color: #00a89d;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    margin-bottom: 10px;
}
</style>